import { NotificationI } from '../../../types';
import { observer } from 'mobx-react';
import { requestDetailsModalCall } from '../../../containers/MainWrapper/MainWrapper';
import React from 'react';


interface NotificationCancelledPropsI {
  message: NotificationI,
  deleteNotif: (msgId: number) => void,
  onClose: () => void,
}

export const NotificationCancelled = observer((props: NotificationCancelledPropsI) => {
  const {message, onClose ,  deleteNotif} = props;
  return <div className={'notification_item'}><b>{message.authorName}</b>  has cancelled a <span
    onClick={()=>{
      onClose();
      deleteNotif(message.id);
      requestDetailsModalCall.showImmediately({id: message.leaveRequestId });
    }}> leave request</span>.</div>;
});